import React from 'react';
import Select from 'react-select';

import CheckBoxOption from './react-select-custom-child-components/checkbox-option';
import NewValueContainer from './react-select-custom-child-components/new-value-container';

function getEmptyFilter(placeholder: string = '', extraOptions: object[] = [], label = '') {
  const SelectDropdown = ({
    items,
    refine,
  }) => {
    const options = [...extraOptions];
    const selectedValue: any[] = [];

    items.map((item) => {
      const itemObj = {
        value: item.value,
        label: item.label,
      };
      options.push(itemObj);
      if (item.isRefined) {
        selectedValue.push(itemObj);
      }
      return true;
    });
    return (
      <Select
        aria-label={label || placeholder}
        className="d-none"
        classNamePrefix="algolia-select"
        value={selectedValue}
        components={{
          ValueContainer: NewValueContainer,
          Option: CheckBoxOption,
        }}
        onChange={(event) => {
          if (event.value === 'all') {
            refine('');
            return;
          }
          refine(event.value);
        }}
        isSearchable={true}
        options={options}
        placeholder={placeholder}
      />
    );
  };
  return SelectDropdown;
}

export default getEmptyFilter;
